import { ArrowUpRight } from "lucide-react";
import { createWhatsAppLink } from "../lib/whatsapp";

export function ServiceCard({ name, index }) {
  return (
    <article className="service-card" data-testid={`service-card-${index}`}>
      <span className="service-number" data-testid={`service-card-number-${index}`}>{String(index + 1).padStart(2, "0")}</span>
      <h3 data-testid={`service-card-title-${index}`}>{name}</h3>
      <p data-testid={`service-card-description-${index}`}>Atendimento local em Arujá/SP com orientação direta pelo WhatsApp.</p>
      <a href={createWhatsAppLink(`Olá, preciso de informações sobre ${name} em Arujá.`)} data-testid={`service-card-whatsapp-${index}`}>Consultar serviço <ArrowUpRight size={16} /></a>
    </article>
  );
}